module.exports = __webpack_public_path__ + "static/media/Sale_Post01-Image.fe2bc9aa.jpg";